// Utility to reorder a list by moving an item after another
export function reorderList<T extends { id: string }>(
  list: T[],
  id: string,
  afterId?: string
): T[] {
  const arr = [...list];
  const fromIdx = arr.findIndex(x => x.id === id);
  if (fromIdx < 0) return arr;
  const [moved] = arr.splice(fromIdx, 1);
  const insertAt = afterId ? arr.findIndex(x => x.id === afterId) + 1 : 0;
  const clamped = Math.max(0, Math.min(insertAt, arr.length));
  arr.splice(clamped, 0, moved);
  return arr;
}
